module.exports = "/_next/static/images/monitoralt-026ecf03e4dc293b19f0138376d2e0ba.svg";